// Base path for the conversations-service question-classification summary API.
// The summary endpoint lives at `${QUERY_INSIGHTS_API}/summary`.
export const QUERY_INSIGHTS_API = "/api/ai/v1/classifications";

export const QUERY_INSIGHTS_PAGE_TITLE = "AI Query Insights";

// The originating apps the dashboard reports on: the go-forward Project session
// (nextgen) and its legacy predecessor, the Dataset Assistant. Sent to the
// summary endpoint so every figure covers just these two apps.
export const QUERY_INSIGHTS_APP_IDS = ["PROJECT_ASSISTANT", "DATASET_ASSISTANT"] as const;
